<template>
  <section style="min-heihgt:600px">
      <div v-if="this.$store.state.loading_home&&this.loadingSlider" class="d-flex flex-row justify-content-center loading_card">
            <!-- LOADER -->
            <div class="loading_card_spinner">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="35" :dots-num="3"
                    color="var(--primary-color)" />

            </div>
        </div>
    <div id="heroCarousel" class="carousel slide" v-if="sliders.length!=0">

      <VueSlickCarousel v-bind="settings" ref="carouselBanner" class="carousel-inner" dir="ltr">
        <div v-for="(item, idx) in sliders" :key="idx" class="carousel-item banner_home active">
          <img :src="item.image" class="d-block w-100" >
        </div>
      </VueSlickCarousel>

    </div>

    <div v-else id="heroCarousel" class="carousel slide" >

      <div class="carousel-inner" dir="ltr">
        <div  class="carousel-item banner_home active">
          <img src="https://etrolley.net/store/assets/image/slide1.jpg" class="d-block w-100">
        </div>
      </div>

    </div>


    <!-- Controls + Counter under the slider -->
    <div class="d-flex justify-content-center align-items-center mt-3 gap-2">
      <button id="prevBtn" class="btn "@click="goPrevBanner">
        <i class="bi bi-chevron-left" style="font-size: 12px;"></i>
      </button>

      <div id="slideCounter" style="font-size: 12px; color: #857e7e;;">1 / {{sliders.length}}</div>

      <button id="nextBtn" class="btn " @click="goNextBanner">
        <i class="bi bi-chevron-right" style="font-size: 12px;"></i>
      </button>
    </div>


    <hr>

    <!-- sections -->
      <sections_home v-if="this.$store.state.apperance_sections==1"></sections_home>
     <!-- end sections -->
    <!-- Product Section -->
    <div class="container py-5" v-if="(this.$store.state.apperance_latest_products == 1)&&(products.length != 0)">
      <div v-if="loadingProduct" class="empty text-center center-text">

        <img src="/pet_shop/assets/images/ajax-loader.gif" />
        <br>

      </div>
      <div v-else>
         <div class="d-flex justify-content-between">
        <p class="mb-4 trirong " style="font-size: 37px;">{{ $t('Latest products') }}</p>
         <router-link  :to="{
                      name: 'products',
                      params: {
                        storeName: $store.storeName,
                        lang: $i18n.locale
                      },}"
                       class="mb-4 trirong all_product">{{$t('all') }}</router-link>
                       </div>
       
        <div class="row row-cols-2 row-cols-md-3 row-cols-lg-6 g-4">
          <!-- Repeat this card for each product -->
          <product v-for="(item, index) in this.products" :key="index" :name="item.name" :description="item.description"
            :is_favorit="item.is_favorit" :image="item.image" :old_price="item.old_price" :new_price="item.new_price"
            :productid="item.id" :rate="item.rate" :count_view="item.count_views" :is_option="item.is_option"
            :is_offer="item.is_offer" :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured"
            :discount="item.discount" :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
            :range_price="item.range_price"></product>
        </div>
      </div>
    </div>
    <!-- sold -->
      <div class="container py-5" v-if="(this.$store.state.apperance_best_saller==1)&&(sallerProducts.length != 0)">
      <div v-if="best_products_loading" class="empty text-center center-text">

        <img src="/pet_shop/assets/images/ajax-loader.gif" />
        <br>

      </div>
      <div v-else>
         <div class="d-flex justify-content-between">
        <p class="mb-4 trirong " style="font-size: 37px;">{{ $t('Best Seller Items') }}</p>
         <router-link  :to="{
                      name: 'products',
                      params: {
                        storeName: $store.storeName,
                        lang: $i18n.locale
                      },}"
                       class="mb-4 trirong all_product">{{$t('all') }}</router-link>
                       </div>
        <div class="row row-cols-2 row-cols-md-3 row-cols-lg-6 g-4">
          <!-- Repeat this card for each product -->
          <product v-for="(item, index) in this.sallerProducts" :key="index" :name="item.name" :description="item.description"
            :is_favorit="item.is_favorit" :image="item.image" :old_price="item.old_price" :new_price="item.new_price"
            :productid="item.id" :rate="item.rate" :count_view="item.count_views" :is_option="item.is_option"
            :is_offer="item.is_offer" :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured"
            :discount="item.discount" :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
            :range_price="item.range_price"></product>
        </div>
      </div>
    </div>
     <!-- end sold -->

        <!-- fetured -->
      <div class="container py-5" v-if="(this.$store.state.apperance_fetured_products==1)&&(feautredProducts.length!=0)">
      <div v-if="feautred_products_loading" class="empty text-center center-text">

        <img src="/pet_shop/assets/images/ajax-loader.gif" />
        <br>

      </div>
      <div v-else>
         <div class="d-flex justify-content-between">
        <p class="mb-4 trirong " style="font-size: 37px;">{{$t('Featured products')}}</p>
         <router-link  :to="{
                      name: 'products',
                      params: {
                        storeName: $store.storeName,
                        lang: $i18n.locale
                      },}"
                       class="mb-4 trirong all_product">{{$t('all') }}</router-link>
                       </div> 
        <div class="row row-cols-2 row-cols-md-3 row-cols-lg-6 g-4">
          <!-- Repeat this card for each product -->
          <product v-for="(item, index) in this.feautredProducts" :key="index" :name="item.name" :description="item.description"
            :is_favorit="item.is_favorit" :image="item.image" :old_price="item.old_price" :new_price="item.new_price"
            :productid="item.id" :rate="item.rate" :count_view="item.count_views" :is_option="item.is_option"
            :is_offer="item.is_offer" :unit="item.unit" :new="item.is_new" :fetuered="item.is_fetured"
            :discount="item.discount" :qnt="item.qnt" :min_qnt="item.min_qnt" :max_qnt="item.max_qnt" :note="item.note"
            :range_price="item.range_price"></product>
        </div>
      </div>
    </div>
     <!-- end fetured -->

  </section>
</template>

<script>

import VueSlickCarousel from 'vue-slick-carousel';
import product from "../components/one_product.vue";
import sections_home from "../components/sections_home.vue";
import { HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner } from "epic-spinners";

export default {
  components: {
 HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner,
    VueSlickCarousel,
    product,
    sections_home
  },
  data() {
    return {
      sliders: [{ icon: "https://etrolley.net/store/assets/image/slide1.jpg", name: "Category 1" },
      { icon: "https://etrolley.net/store/assets/image/slide1.jpg", name: "Category 1" },
     { icon: "https://etrolley.net/store/assets/image/slide1.jpg", name: "Category 1" }
      ],
      DBitems: null,
      loading: false,
      langChange: "",
      sort: 'id',
      order: 'desc',
      paginate: 12,
      section_length: 0,
      DBitems: null,

      loadingSection: false,
      loadingSlider: false,
      loadingProduct: true,
      loadingCategory: false,
      loadingPost: false,

      products: [
      ],
      best_products_loading: false,
      sallerProducts: [],
      feautred_products_loading: false,
      feautredProducts: [],
      page: 1,
      count: 0,
      pageSize: 6,
      langChange: "",
      sort: 'id',
      order: 'desc',
      paginate: 6,
      type: 'new',
      settings: {
        "dots": true,
        "arrows": true,
        "prevArrow": '<button class="prev">❮</button>',
        "nextArrow": '<button class="next">❯</button>',
        "speed": 5000,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "infinite": true,
        "autoplay": true,
        "autoplaySpeed": 5000,
        "rows": 1
      },
      loading_featured_products: true,
    }
  },
  created() {
    //sliders
    this.$store.state.showHeader = true;
    this.$store.state.showFooter = true;

    this.loadingSlider = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/sliders",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        }
      )
      .then((response) => {
        this.sliders = response.data.data.sliders;


      })
      .then(() => {
        this.loadingSlider = false;
        console.log('sliders section', this.sliders)

      });

    //products

    // new products
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/type/new?limit=6",

        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
          }
        }

      )
      .then((response) => {
        this.products = response.data.data;

      })
      .then(() => (this.loadingProduct = false));
    //end new products
    //

    //best saller
    this.best_products_loading = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/type/best_saller?limit=6",

        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
          }
        }

      )
      .then((response) => {
        this.sallerProducts = response.data.data;

      })
      .then(() => (this.best_products_loading = false));
    //end best saller

    //feautred

    this.loading_featured_products = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/type/feautred?limit=6",

        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
          }
        }

      )
      .then((response) => {
        this.feautredProducts = response.data.data;

      })
      .then(() => (this.loading_featured_products = false));
    //end feautred
  },
  watch: {
    langChange() {
    //sliders

    this.loadingSlider = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/sliders",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        }
      )
      .then((response) => {
        this.sliders = response.data.data.sliders;


      })
      .then(() => {
        this.loadingSlider = false;
        console.log('sliders section', this.sliders)

      });

    //products

    // new products
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/type/new?limit=6",

        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
          }
        }

      )
      .then((response) => {
        this.products = response.data.data;

      })
      .then(() => (this.loadingProduct = false));
    //end new products
    //

    //best saller
    this.best_products_loading = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/type/best_saller?limit=6",

        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
          }
        }

      )
      .then((response) => {
        this.sallerProducts = response.data.data;

      })
      .then(() => (this.best_products_loading = false));
    //end best saller

    //feautred

    this.loading_featured_products = true;
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/theme8/products/type/feautred?limit=6",

        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
          }
        }

      )
      .then((response) => {
        this.feautredProducts = response.data.data;

      })
      .then(() => (this.loading_featured_products = false));
    //end feautred
  },
  },
  updated() {
    this.langChange = this.$i18n.locale
  },

  methods: {
    goNextBanner() {
      this.$refs.carouselBanner.next();
    },
    goPrevBanner() {
      this.$refs.carouselBanner.prev();
    },
  }

};
</script>
